import { FormStore, GlobalStore } from '@roc/feature-app-core';
import { ReferralsService } from '../services';
import { flow, makeObservable } from 'mobx';
import { isCivicUrl, isFacoUrl } from '@roc/feature-utils';

const form = {
  fields: {
    firstName: {
      value: '',
      error: null,
      rule: 'required',
      attribute: 'first name',
    },
    lastName: {
      value: '',
      error: null,
      rule: 'required',
      attribute: 'last name',
    },
    phone: {
      value: '',
      error: null,
      rule: 'required',
    },
    email: {
      value: '',
      error: null,
      rule: 'required',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class ReferralFormStore extends FormStore {
  private globalStore: GlobalStore;
  private referralService: ReferralsService;

  constructor(globalStore: GlobalStore) {
    super(form, globalStore);
    this.globalStore = globalStore;
    this.referralService = new ReferralsService();
    makeObservable(this, {
      addReferral: flow,
      deleteReferral: flow,
    });
  }

  *addReferral(
    userId: number,
    contactId: number,
    callback = () => { }
  ) {
    this.runFormValidationWithMessage()
    if (this.form.meta.isValid) {
      yield this.referralService.addReferral({
        ...this.getFormValues(),
        businessUnit: isCivicUrl() ? 'CIVIC' : isFacoUrl() ? 'FACO' : null,
        userId: userId,
        contactId: contactId
      });
      callback();
    }
  }

  *deleteReferral(referralId: number) {
    yield this.referralService.deleteReferral(referralId);
  }
}
